<template>
  <div class="popup-mask show">
    <div class="popup share-popup">
      <div class="share-header">
        <h3>分享后继续观看</h3>
      </div>

      <p class="share-desc">
        老用户专享福利：请先复制本站链接或保存分享图，分享给好友后即可免费观看完整视频。
      </p>

      <!-- <div class="share-preview">
        <div class="qr-placeholder">
          <img v-if="qrCodeData" :src="qrCodeData" alt="分享二维码" class="qr-image">
          <div v-else class="qr-inner">{{ loading ? "生成中" : "二维码" }}</div>
        </div>
        <div class="share-text">
          <strong>{{ siteName }}</strong>
          <span>{{ shareSubtitle }}</span>
        </div>
      </div> -->

      <!-- <div v-if="posterImg" class="poster-preview">
        <img :src="posterImg" alt="分享海报" class="poster-image">
      </div> -->
 <canvas ref="posterCanvas" :width="canvasWidth" :height="canvasHeight" class="poster-canvas"></canvas>
      <div class="form-actions">
        <!-- <div class="btn" @click="handleShare">
          {{ loading ? '海报生成中...' : '保存分享图并继续观看' }}
        </div> -->
        <div class="ghost-btn" @click="handleCopy">
          复制链接分享
        </div>
        <router-link class="ghost-btn" to="/">
          返回首页
        </router-link>
        <div class="ghost-btn" @click="closeModal">关闭</div>
      </div>

      <div class="helper-text" :class="feedbackClass">{{ feedbackText }}</div>
     
    </div>
  </div>
</template>

<script>
import { copyCurrentLink } from "@/prototype/render-helpers";
import { addShareApi, sdV2Api } from "@/api/api";
import { siteData } from "@/prototype/site-data";
import QRCode from "qrcode";

export default {
  name: "ShareModal",
  data() {
    return {
      siteName: siteData.siteName,
      shareSubtitle: "海量视频免费看",
      feedbackText: "",
      feedbackType: "",
      loading: false,
      shareData: {},
      imageUrl: "",
      spreadUrl: "",
      qrCodeData: "",
      posterImg: "",
      canvasWidth: 750,
      canvasHeight: 1100,
      tipUrlList: [],
    };
  },
  mounted() {
    this.bootstrapPoster();
  },
  computed: {
    feedbackClass() {
      if (this.feedbackType === "success") return "success-text";
      if (this.feedbackType === "error") return "error-text";
      return "";
    },
  },
  methods: {
    decryptPayload(payload) {
      try {
        const decryptedText = this.$decryptData(payload);
        return decryptedText ? JSON.parse(decryptedText) : null;
      } catch (error) {
        return null;
      }
    },
    async bootstrapPoster() {
      this.loading = true;
      try {
        const ldk = window.localStorage.getItem("ldk") || "";
        const res = await sdV2Api({ ldk });
        const temp = this.decryptPayload(res);
        if (!temp) {
          this.feedbackType = "error";
          this.feedbackText = "分享海报数据加载失败。";
          return;
        }
        this.shareData = temp;
        this.imageUrl = temp.backimg || "";
        this.spreadUrl = temp.spreadurl || window.location.href;
        this.tipUrlList = Array.isArray(temp.tipUrlList) ? temp.tipUrlList : [];
        this.shareSubtitle = temp.tip_content || this.shareSubtitle;
        await this.generateQRCode();
        await this.drawPoster();
      } catch (error) {
        this.feedbackType = "error";
        this.feedbackText = "分享海报生成失败，请稍后重试。";
      } finally {
        this.loading = false;
      }
    },
    async generateQRCode() {
      this.qrCodeData = await QRCode.toDataURL(this.spreadUrl || window.location.href, {
        width: 180,
        margin: 1,
      });
    },
    drawImage(ctx, src, x, y, width, height) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = src;
        img.onload = () => {
          ctx.drawImage(img, x, y, width, height);
          resolve();
        };
        img.onerror = reject;
      });
    },
    async drawPoster() {
      const canvas = this.$refs.posterCanvas;
      if (!canvas) {
        return;
      }

      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

      if (this.imageUrl) {
        await this.drawImage(ctx, this.imageUrl, 50, 50, this.canvasWidth - 100, 500);
      }

      ctx.fillStyle = "#111111";
      ctx.font = "bold 42px Arial";
      ctx.fillText(this.siteName, 58, 620);

      ctx.fillStyle = "#e53935";
      ctx.font = "bold 34px Arial";
      ctx.fillText(this.shareData.tip_content || "保存海报不迷路", 58, 680);

      ctx.fillStyle = "#222222";
      ctx.font = "bold 30px Arial";
      ctx.fillText("永久网址", 58, 760);
      ctx.fillText("扫码直达", 430, 760);

      const lines = this.tipUrlList.slice(1, 4);
      lines.forEach((line, index) => {
        ctx.fillStyle = "#000000";
        ctx.font = "bold 32px Arial";
        ctx.fillText(line, 58, 830 + index * 72);
      });

      ctx.fillStyle = "#d81b60";
      ctx.font = "bold 32px Arial";
      ctx.fillText("保存分享图后继续观看", 58, 1040);

      if (this.qrCodeData) {
        await this.drawImage(ctx, this.qrCodeData, 430, 800, 220, 220);
      }

      this.posterImg = canvas.toDataURL("image/png");
    },
    async reportShareSuccess() {
      try {
        await addShareApi();
      } catch (error) {
        // ignore report failure for H5 flow
      }
    },
    triggerPosterDownload() {
      if (!this.posterImg) {
        return false;
      }
      const link = document.createElement("a");
      link.href = this.posterImg;
      link.download = "3p-share-poster.png";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    },
    async handleShare() {
      if (this.loading) {
        this.feedbackType = "error";
        this.feedbackText = "海报还在生成中，请稍候。";
        return;
      }
      if (!this.posterImg) {
        await this.bootstrapPoster();
      }
      if (!this.posterImg) {
        this.feedbackType = "error";
        this.feedbackText = "海报生成失败，请稍后重试。";
        return;
      }

      this.triggerPosterDownload();
      await this.reportShareSuccess();
      this.feedbackType = "success";
      this.feedbackText = "已尝试自动保存海报，如未下载请长按下方海报保存。";
      setTimeout(() => {
        this.$emit("success");
      }, 800);
    },
    async handleCopy() {
      try {
        await copyCurrentLink();
        await this.reportShareSuccess();
        this.feedbackType = "success";
        this.feedbackText = "链接已复制，去分享给好友吧！";
        setTimeout(() => {
          this.$emit("success");
        }, 1500);
      } catch (error) {
        this.feedbackType = "error";
        this.feedbackText = "复制失败，请手动分享。";
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.share-popup {
  text-align: center;
}

.share-header {
  margin-bottom: 12px;
}

.share-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
}

.share-desc {
  font-size: 13px;
  color: var(--muted);
  line-height: 1.5;
  margin-bottom: 20px;
}

.share-preview {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  border: 1px solid var(--line);
}

.qr-placeholder {
  width: 120px;
  height: 120px;
  background: #ffffff;
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.qr-inner {
  width: 100%;
  height: 100%;
  background: var(--text);
  color: #ffffff;
  display: grid;
  place-items: center;
  font-size: 14px;
  font-weight: bold;
}

.qr-image {
  width: 100%;
  height: 100%;
  display: block;
}

.share-text strong {
  display: block;
  font-size: 16px;
  color: var(--text);
  margin-bottom: 4px;
}

.share-text span {
  font-size: 12px;
  color: var(--primary);
}

.ghost-btn {
  text-decoration: none;
}

.poster-preview {
  margin-bottom: 20px;
  border: 1px solid var(--line);
  border-radius: 8px;
  overflow: hidden;
  background: #f7f8fa;
}

.poster-image {
  display: block;
  width: 100%;
}

.poster-canvas {
  display: none;
}
</style>
